import React, { useState } from 'react';
import { List, Input, Button, Typography } from 'antd';
import { chatMessages } from '../mockData';
import './Chat.css';

function AgencyChat() {
  const { Title } = Typography;
  const [messages, setMessages] = useState(chatMessages);
  const [text, setText] = useState('');

  const send = () => {
    if (!text.trim()) return;
    const nextId = (messages[messages.length - 1]?.id || 0) + 1;
    const newMsg = { id: nextId, from: 'You', message: text.trim(), time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) };
    setMessages([...messages, newMsg]);
    setText('');
    console.log('Mock send message', newMsg);
  };

  return (
    <div className="agency-chat">
      <Title level={3}>Agency Chat</Title>
      <List
        bordered
        dataSource={messages}
        style={{ marginBottom: 12, background: '#fff' }}
        renderItem={(m) => (
          <List.Item>
            <List.Item.Meta
              title={`${m.from} · ${m.time}`}
              description={m.message}
            />
          </List.Item>
        )}
      />
      <div style={{ display: 'flex', gap: 8 }}>
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type a message..." onPressEnter={send} />
        <Button type="primary" onClick={send}>Send</Button>
      </div>
    </div>
  );
}

export default AgencyChat;
